import * as type from '../actions/types';

const initialState = {
  data: [],
  error: '',
  pending: true,
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_DIETARY_TAGS_PENDING: {
      return {
        ...state,
        error: '',
        pending: true,
        success: false,
      };
    }

    case type.FETCH_DIETARY_TAGS_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        pending: false,
        success: true,
      };
    }

    case type.FETCH_DIETARY_TAGS_FAILURE: {
      return {
        ...state,
        pending: false,
        error: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};
